var paragraph_default = {
  "fontElementMap": "_7SISi",
  "elementSpacing": "NlrTp",
  "text": "a4yOF NlrTp",
  "child": "lMv7L"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
